import * as React from 'react';
// @todo: Move all titles specific styles to a index.styl inside this folder
var updateWindowHash = function (id) {
    window.location.hash = id;
};
export var Title = function (_a) {
    var children = _a.children, anchor = _a.anchor, tag = _a.tag;
    return (React.createElement("div", { id: anchor, className: "header-wrapper header-level-".concat(tag), onClick: function () { return updateWindowHash(anchor); }, dangerouslySetInnerHTML: { __html: children } }));
};
